/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_TitleInputs */

const cs_clients_comm_title = /** @type {(inputs: Clients_Comm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunikace`)
};

const en_clients_comm_title = /** @type {(inputs: Clients_Comm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communication`)
};

/**
* | output |
* | --- |
* | "Communication" |
*
* @param {Clients_Comm_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_title = /** @type {((inputs?: Clients_Comm_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_title(inputs)
	return cs_clients_comm_title(inputs)
});